import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../../../_models/field.interface";
@Component({
  selector: "app-radioButton",
  template: `
<div [formGroup]="group"
[ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null"
*ngIf="field.visible != null ? (!field.visible ? false : true) : true">
<mat-radio-group [formControlName]="field.name" [ngStyle]="field.style()">
<mat-radio-button *ngFor="let item of field.multiOptions" [value]="item.value" [checked]="item.checked" (change)="field.change ? field.change($event) : null" style="padding-right: 10px; display: block; margin-left: 15px; margin-top: 10px; margin-bottom: 15px; box-shadow: '0px 10px 46px 10px rgba(198, 198, 198, 0.2)'; border-radius: 16px; height: 35px">{{item.value}}</mat-radio-button>
</mat-radio-group>
</div>
`,
  styles: []
})
export class RadiobuttonComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() {}
  ngOnInit() {}
}
